import { API } from 'api';
import fileDownload from 'js-file-download';
import { useQuery, useMutation } from 'react-query';

interface IGetTransactionHistory {
  payload: {
    eid: string;
    pageSize?: number;
    page?: number;
    ebid?: string;
    startDate?: string | null;
    endDate?: string | null;
  };
}

export const getTransactionHistory = async (payload: IGetTransactionHistory['payload']) =>
  API.get()(`/api/admin/reward/transactions`, {
    eid: payload.eid,
    ...(payload?.pageSize && { pageSize: payload.pageSize }),
    ...(payload?.page && { page: payload.page }),
    ...(payload?.ebid && { ebid: payload.ebid }),
    ...(payload?.startDate && { startDate: payload.startDate }),
    ...(payload?.endDate && { endDate: payload.endDate }),
  });

export const useTransactionHistory = (payload: IGetTransactionHistory['payload'], options: { enabled: boolean }) => {
  return useQuery(['transactionHistory', payload], (): any => getTransactionHistory(payload), {
    enabled: options?.enabled ?? true,
    select: (response: any) => response.data?.data,
  });
};
export const downloadTransactionHistory = (payload: IGetTransactionHistory['payload']) => {
  return useMutation(getTransactionHistory, {
    onSuccess: async ({ data }: any) =>
      fileDownload(data, `${payload.ebid ? `${payload.ebid} - ` : ''}${payload.eid} Points Transaction History.csv`),
  });
};
